import { configApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import { useState, useCallback, useEffect } from 'react';

type Response = {
  id: string;
  error_event_id: string;
  task_id: string;
  created_at: string;
};

export function useGetErrorTrackingTask({ errorEventId, onError, onSuccess }: { errorEventId: string, onError?: () => void, onSuccess?: () => void }) {
  const [data, setData] = useState<Response | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchApi = useApi(fetchApiRef);
  const configApi = useApi(configApiRef);
  const backendUrl = configApi.getString('backend.baseUrl');

  const execute = useCallback(async (errorEventId: string) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const response = await fetchApi.fetch(`${backendUrl}/api/uptime-monitor/proxy/error-tracking-tasks/${errorEventId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if(!response.ok) {
        throw new Error("Failed to get error tracking task")
      }

      const result = await response.json()
      setData(result);
      onSuccess?.()
    } catch (error) {
      setIsError(true);
      onError?.()
    } finally {
      setIsLoading(false);
    }
  }, []);
  
  const refetch = useCallback(() => {
    execute(errorEventId);
  }, [execute, errorEventId]);
  
  useEffect(() => {
    execute(errorEventId);
  }, [execute, errorEventId]);

  return {
    data,
    isLoading,
    isError,
    execute,
    refetch,
  };
}
